import React from "react";

const AboutUs = () => {
  return (
    <section className="bg-[#faf7f2] py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-[#8B5E3C]">
            About Us
          </h2>
          <p className="text-gray-600 mt-4 max-w-3xl mx-auto text-lg">
            We are a leading Handicrafts Manufacturing Company based in Jaipur,
            Rajasthan, bringing traditional Indian craftsmanship to global
            markets.
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
            <p>
              With an extensive catalog of{" "}
              <span className="font-semibold text-[#8B5E3C]">85,000+ SKUs</span>
              , we specialize in bulk export of premium handcrafted products
              across international markets.
            </p>

            <p>
              Our strong manufacturing network and skilled artisans ensure
              superior quality, authentic designs, and timely delivery.
            </p>

            <p>
              We also empower enrolled sellers by offering products with
              <span className="font-semibold text-[#8B5E3C]">
                {" "}
                No MOQ (Minimum Order Quantity)
              </span>
              , making it easier for businesses of all sizes to grow with us.
            </p>

            <div className="flex gap-6 pt-4">
              <div>
                <h3 className="text-3xl font-bold text-[#8B5E3C]">85,000+</h3>
                <p className="text-gray-600">Product SKUs</p>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-[#8B5E3C]">Global</h3>
                <p className="text-gray-600">Bulk Exporter</p>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-[#8B5E3C]">No MOQ</h3>
                <p className="text-gray-600">For Sellers</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1596461404969-9ae70f2830c1"
              alt="Handicraft artisans"
              className="rounded-2xl shadow-2xl object-cover w-full h-[400px]"
            />
            <div className="absolute inset-0 bg-[#8B5E3C]/10 rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
